import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CartContext = createContext(null);

const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD': {
      const key = `${action.payload._id}__${action.payload.variantSize || ''}`;
      const existing = state.items.find(i => `${i._id}__${i.variantSize || ''}` === key);
      if (existing) {
        return {
          ...state,
          items: state.items.map(i =>
            `${i._id}__${i.variantSize || ''}` === key
              ? { ...i, quantity: Math.min(i.quantity + 1, i.stock || 99) }
              : i
          ),
        };
      }
      return { ...state, items: [...state.items, { ...action.payload, quantity: 1 }] };
    }
    case 'REMOVE':
      return { ...state, items: state.items.filter(i => !(i._id === action.id && (i.variantSize || '') === (action.variantSize || ''))) };
    case 'UPDATE_QTY':
      if (action.quantity < 1) {
        return { ...state, items: state.items.filter(i => !(i._id === action.id && (i.variantSize || '') === (action.variantSize || ''))) };
      }
      return {
        ...state,
        items: state.items.map(i =>
          i._id === action.id && (i.variantSize || '') === (action.variantSize || '')
            ? { ...i, quantity: action.quantity }
            : i
        ),
      };
    case 'SET_COUPON':
      return {
        ...state,
        appliedCoupon: action.payload.coupon,
        discount: action.payload.discount,
        freeShippingBypass: action.payload.freeShipping
      };
    case 'REMOVE_COUPON':
      return {
        ...state,
        appliedCoupon: null,
        discount: 0,
        freeShippingBypass: false
      };
    case 'CLEAR':
      return { items: [], appliedCoupon: null, discount: 0, freeShippingBypass: false };
    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, { items: [], appliedCoupon: null, discount: 0, freeShippingBypass: false }, init => {
    try { const s = localStorage.getItem('jo_cart_v2'); return s ? JSON.parse(s) : init; }
    catch { return init; }
  });

  useEffect(() => {
    try { localStorage.setItem('jo_cart_v2', JSON.stringify(state)); } catch {}
  }, [state]);

  const subtotal = state.items.reduce((s, i) => s + i.price * i.quantity, 0);
  const itemCount = state.items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{
      items: state.items, 
      subtotal, 
      itemCount,
      appliedCoupon: state.appliedCoupon,
      discount: state.discount,
      freeShippingBypass: state.freeShippingBypass,
      addItem: (p) => dispatch({ type: 'ADD', payload: p }),
      removeItem: (id, variantSize) => dispatch({ type: 'REMOVE', id, variantSize }),
      updateQuantity: (id, quantity, variantSize) => dispatch({ type: 'UPDATE_QTY', id, quantity, variantSize }),
      setCouponData: (data) => dispatch({ type: 'SET_COUPON', payload: data }),
      removeCoupon: () => dispatch({ type: 'REMOVE_COUPON' }),
      clearCart: () => dispatch({ type: 'CLEAR' }),
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart outside CartProvider');
  return ctx;
};